export default {
  //代码里的key(唯一标识): '葡萄牙语',
  lang: 'pt',
  appIntroduction: 'Filmes e novelas populares para assistir gratuitamente a qualquer hora',
  noMoreTip: 'Fim, não há mais conteúdo~',
  navigator: {
    home: 'Página inicial',
    all: 'Todos os conteúdos',
    news: 'Notícias',
    download: 'Baixar aplicativos',
    contact: 'Sobre nós',
    joinUs: 'Junte-se a nós'
  },
  seo: {
    title: 'Loklok Watch\' HD movies online for free',
    keywords: 'Loklok, Loklok app, loklok tv, Loklok official website, Loklok web,Loklok movie,assistir online, assistir de graça, assistir drama de graça, new movies,tv show,Snowdrop,Hotel Transylvania,Encanto,The Silent Sea,Jujutsu Kaisen,9-1-1: Lone Star,Hotel Transylvania,Dragons,SnowdropOur Beloved SummerDemon SlayerHappinessSing 2Ranking of KingsDemon SlayerAttack on TitanTrue BeautyVincenzoAttack on Titan The Final SeasonJujutsu KaisenThe HandmaidenTokyo RevengersNeverthelessItaewon ClassSquid GameCrash Landing on YouEuphoriaAttack on TitanHometown Cha-Cha-Cha',
    description: 'Popular episodes updated quickly,American hot series,Tension, comedy, thriller,Newest hottest dramasall in Loklok',
    ogImage: 'https://static.loklok.video/img/tw-en.png',
    index: {
      title: 'Loklok - Assista a filmes em HD online gratuitamente - Recomendação de filmes mais bem avaliados',
      keywords: 'Loklok, aplicativo Loklok, baixar loklok, baixar loklok, loklok pc, loklok apk,assistir online, assistir de graça, assistir drama de graça, loklok ios, loklok android, loklok para ios, loklok para android, loklok android tv, loklok chromecast, kdrama, k-drama, drama coreano, bilheteria, filmes americanos, filmes ocidentais, filmes de grande sucesso, filmes tailandeses, filmes tailandeses, drama de TV, séries de TV, anime, animação, desenho animado, programa de variedades, yaoi, yuri, bl, gl, hollywood, bollywood, zumbi, uma peça, naruto, amor caso, todos nós estamos mortos',
      description: 'Assista a filmes populares, séries de TV, animações de todo o mundo online gratuitamente em 4K Ultra HD com legendas em vários idiomas no Loklok'
    },
    allPage: {
      title: 'Loklok Assista a filmes em HD online gratuitamente, qualquer coisa que você possa imaginar.',
      keywords: 'Loklok, aplicativo Loklok, download loklok, pc loklok, apk loklok,assistir online, assistir de graça, assistir drama de graça,animação, anime, filmes de grande sucesso, novo episódio, próximos filmes, lançamento de 2022, estreia, ficção científica, doce romance, comédia, ação, amor, filmes grátis, grátis filmes online, aplicativo de filmes grátis, todos nós estamos mortos, F4 Tailândia: Boys Over Flowers, Euphoria Season 2, Twenty Five Twenty One, Previsão de Amor e Clima, Doutor Fantasma, Verdadeira Beleza, Encanto, De, Proposta de Negócios, Snowdrop, Novato Policiais，Ainda 2 juntos',
      description: 'Assista a filmes, dramas de TV e anime online grátis online, Ultra HD 4K HD com legendas multilíngues, tudo em Loklok'
    },
    articles: {
      title: 'Loklok Assista a filmes em HD online gratuitamente, loklok últimas notícias',
      keywords: 'Loklok, aplicativo Loklok, download loklok, pc loklok, apk loklok,assistir online, assistir de graça, assistir drama de graça, informações mais recentes sobre filmes e televisão, recomendações de filmes, resenhas de filmes populares, filme e televisão de 2022, estreia do filme, 2022 vale a pena assistir, 2022 deve ser assistido, filmes de cinema de 2022, próximos filmes 2023 , Peaky Blinders Temporada 6, Ataque ao Titã Temporada Final, Nosso Amado Verão, Hotel Transilvânia 4: Transformania, Felicidade',
      description: 'Os rankings de vários filmes e séries de TV populares ao redor do mundo são atualizados 24 horas por dia, e filmes e séries de TV populares são apresentados em tempo real. Venha para o Loklok para perseguir seus filmes.'
    },
    download: {
      title: 'Lokok fornece o download da versão oficial mais recente',
      keywords: 'Loklok, Loklok app, loklok download, loklok pc, loklok apk, loklok download, download loklok,assistir online, assistir de graça, assistir drama de graça, loklok download apk, loklok ios download, loklok android download, loklok googleplay, loklok pc download, loklok versão mais recente, site oficial do loklok, como baixar Loklok, área de trabalho Loklok, teclado Loklok',
      description: 'Baixe o aplicativo Loklok e assista a filmes e programas de TV online gratuitos a qualquer hora, em qualquer lugar. Após a instalação, escaneie o código QR do site com seu celular para assistir online ao mesmo tempo no PC.'
    },
    search: {

    },
    contact: {
      title: 'Entre em contato conosco por E-mail, Twitter, Facebook, Instagram e Youtube. - Loklok',
      keywords: 'Twitter, Facebook, Instagram,assistir online, assistir de graça, assistir drama de graça, Youtube, Contact, E-mail',
      description: 'Dúvidas sobre loklok podem ser comunicadas via e-mail, Twitter, Facebook, Instagram e Youtube'
    }
  },
  globalTip: {
    emptyTip: 'Nada～',
    searchOther: 'Tente procurar outros filmes ou séries'
  },
  loginModule: {
    title: 'Login',
    loginMethod: 'Use Loklok para escanear o código QR',
    loginMethodTip: '（Precisa atualizar para a versão para1.7.0 e superior）',
    howToDownload: 'Como baixar loklok',
    clickMe: 'Clique em mim',
    loginSuccess: 'Login com sucesso',
    loginFailed: 'Falha ao login',
    codeExpired: 'O código QR expirou!',
    refreshButton: 'Atualizar',
    loginButton: 'Login',
    loginTip: 'Assista todos os conteúdos do site gratuitamente após o login',
    logoutButton: 'Sair do login',
    logoutTip: 'Aproveite o filme!',
    areYouSure: 'Tem certeza que deseja sair?',
    sure: 'Ok',
    cancel: 'Cancelar'
  },
  toTop: {
    downloadApp: 'Baixar aplicativo',
    backToTop: 'Voltar ao topo'
  },
  indexPage: {
    title: 'LolokTV',
    more: 'Mais',
    seeMore: 'Ver mais'
  },
  searchPage: {
    resultTitle: 'Procurar Resultados:',
    rank: 'O mais popular de Loklok',
    play: 'Reproduzir',
    popularSearch: 'Pesquisa popular',
    top1: 'No.1',
    top2: 'No.2',
    top3: 'No.3',
    top4: 'No.4',
    top5: 'No.5',
    top6: 'No.6',
    top7: 'No.7',
    top8: 'No.8',
    top9: 'No.9',
    top10: 'No.10',
    emptyTip: 'Desculpe, não temos esse conteúdo',
    emptyDesc: 'Tente pesquisar outros filmes ou programas de TV'
  },
  filterPage: {
    emptyTip: 'Desculpe, não temos esse conteúdo',
    emptyDesc: 'Tente pesquisar outros filmes ou programas de TV'
  },
  newsPage: {
    listTitle: 'Últimas notícias'
  },
  downloadPage: {
    scanQR: 'Digitalize o código QR para baixar o aplicativo',
    title1: 'Filmes e dramas populares',
    tip1: 'Assista a qualquer hora gratuitamente',
    title2: 'legendas multilíngues',
    tip2: 'Assista drama facilmente',
    title3: 'Sincronização PC/Telefone em tempo real'
  },
  detailPage: {
    autoTranslation: 'Tradução automática',
    fiveMiniteTip: 'Apenas 5min, assista o filme completo depois',
    loginTip2InDetailPage: 'Use Loklok para escanear o código QR abaixo e assistir o conteúdo restante após fazer o login',
    category: 'Categoria',
    moreDesc: 'Mais',
    youMayLike: 'Conteúdos semelhantes',
    relatedSeries: 'Séries relacionadas',
    norelatedSeries: 'Nenhuma série relacionada',
    emptyDesc: 'Desculpe, não temos esse conteúdo',
    emptyTip: 'Desculpe, não temos esse conteúdo',
    vip: {
      dialog: {
        t1: 'ativar vip',
        t2: 'Ative o VIP no app para ver o conteúdo completo',
        t3: 'Baixe o aplicativo através do método abaixo',
        t4: 'Já tem VIP? <span class="active">Clique aqui para</span> entrar',
        t5: 'Já tem VIP? <span class="active">Atualize</span> e continue assistindo',
        t6: 'Você assistiu {num} minutos, para assistir a versão completa, use o aplicativo ou ative o VIP no aplicativo para continuar assistindo este filme'
      },
      player: {
        tip1: 'Você só pode assistir por {num} minutos. Você pode <span class="active">usar o aplicativo</span> ou <span class="active">ativar o VIP</span> para assistir ao vídeo completo.'
      },
      episodes: {
        tip1: 'Seja VIP e assista a versão completa'
      }
    }
  },
  playerModule: {
    NETWORK_LOADING: 'O navegador está baixando dados',
    NETWORK_NO_SOURCE: 'Nenhuma fonte de áudio/vídeo encontrada',
    MEDIA_ERR_ABORTED: 'O processo de recuperação foi abortado pelo usuário',
    MEDIA_ERR_NETWORK: 'Ocorreu um erro durante o download',
    MEDIA_ERR_DECODE: 'A análise de reprodução falhou: não foi possível reproduzir o arquivo',
    MEDIA_ERR_SRC_NOT_SUPPORTED: 'Formato de áudio/vídeo não compatível',
    REPLAY: 'Reproduzir',
    ERROR: 'Parece haver um problema com a conexão de rede',
    PLAY_TIPS: 'Reproduzir',
    PAUSE_TIPS: 'Pausa',
    PLAYNEXT_TIPS: 'Próximo',
    DOWNLOAD_TIPS: 'Baixar',
    ROTATE_TIPS: 'Girar',
    RELOAD_TIPS: 'Recarregar',
    FULLSCREEN_TIPS: 'Entrar em tela inteira',
    EXITFULLSCREEN_TIPS: 'Sair da tela inteira',
    CSSFULLSCREEN_TIPS: 'Entrar em tela inteira padrão',
    EXITCSSFULLSCREEN_TIPS: 'Sair da tela inteira padrão',
    TEXTTRACK: 'Legendas',
    PIP: 'Imagem em imagem',
    MINIPLAYER: 'Mini-leitor',
    SCREENSHOT: 'Captura de tela',
    LIVE: 'Transmissão ao vivo',
    OFF: 'Desligar',
    MINIPLAYER_DRAG: 'Clique e segure para arrastar o vídeo',
    AIRPLAY_TIPS: 'Airplay',
    onlyPlayTip: 'Reproduza apenas {msg} minutos, faça login para assistir o filme completo',
    loginTextButton: 'Login',
    replayButton: 'Reproduzir',
    nextButton: 'Próximo',
    refreshButton: 'Atualizar',
    episode: 'Episódio'
  },
  contact: {
    business: 'Cooperação empresarial',
    question: 'retorno'
  },
  download_nd: {
    desc: 'Assista a muitos filmes e séries grátis',
    scanQR: 'Digitalize o código QR para baixar o APP ou'
  },
  win: {
    feedback: {
      que: 'Explicação das Perguntas Frequentes',
      que1: 'Perguntas Frequentes',
      content: 'Conteúdo do Feedback',
      contact: ' Informações de Contato',
      submit: 'Submeter feedback',
      tip1: 'Por favor, forneça uma descrição detalhada e você também pode incluir capturas de tela relevantes.',
      tip2: 'Por favor, insira seu e-mail.',
      tip5: 'O tamanho da imagem enviada deve ser inferior a {num}k.',
      tip6: 'Um máximo de 4 imagens pode ser enviado.',
      tip3: 'Submetido, por favor, seja paciente.',
      tip4: 'O conteúdo do feedback deve ter pelo menos 10 palavras.',
      error: 'Erro de Sistema'
    }
  },
  tv: {
    vip: {
      title: 'Por favor, selecione seu produto',
      tip1: 'Você pode visualizar o código QR de pagamento após fazer login.',
      refresh: 'Atualizar',
      tip2: 'Escaneie o código QR para pagamento',
      recharge: 'Acordo de Recarregamento',
      renewal: 'Acordo de Renovação',
      login: 'Faça login agora',
      tip3: 'Veja após o login',
      noOpen: 'VIP Padrão Não Ativado',
      gift: 'Presente',
      succ: 'Atualização bem-sucedida',
      fail: 'Atualização falhou',
      day: 'VIP padrão 1 dia',
      days: 'VIP padrão {x} dias',
      expiration: 'Tempo de expiração VIP padrão: {x}',
      expired: 'Seu VIP expirou, por, renove-o prontamente.',
      interests1: 'Aproveite a qualidade HD 1080P',
      interests2: 'Desbloqueie todo o conteúdo',
      interests3: ' Login em múltiplos dispositivos'
    }
  }
}